import Decimal from "decimal.js";
import toFormat from "lib/toFormat/toFormat";

export const appInitDecimal = () => {
  // Augment Decimal type with toFormat() method
  // new Decimal(1234).toFormat() => "1,234"
  toFormat(Decimal);
};
